import {DeepLinkActionBase} from '../deep-link-action-base';

export class UploadDocumentDeepLinkAction extends DeepLinkActionBase {

  async execute(): Promise<void> {
    await this.services.externalLinks.openUploadDocument();
  }
}
